<div class="title">
	<a [routerLink]="'/reports/' + report_info.id">{{ report_info.name }}</a>
	<mat-icon (click)="click_edit($event, report_info)">edit</mat-icon>
</div>
